import { MouseEvent, useState } from 'react';
import { Modal } from '../../ui/components/Modal';
import { LoginData } from '../types';
import { useAppDispatch } from '../../../store';
import { LoginForm } from './LoginForm';
import { uiActions } from '../../ui/slice';
import { Button } from '../../ui/components/Button';
import { api } from '../../account/api';

export const LoginModal = () => {

  const dispatch = useAppDispatch();
  const [login] = api.useLogInMutation();
  const [error, setError] = useState<string>();

  const doLogin = async (credentials: LoginData) => {
    setError(undefined);
    try {
      await login(credentials).unwrap();
      dispatch(uiActions.setCurrentModal(null));
    }
    catch (e) {
      setError(`${e}`);
    }
  };

  const setModal = (modalKey: string) => (e: MouseEvent) => {
    dispatch(uiActions.setCurrentModal({ modal: modalKey }));
    e.preventDefault();
  };

  return (
    <Modal
      height={50}
      modalKey='login'
      width={30}
    >
      <h2 className='text-center text-2xl mb-4'>Sign in</h2>
      <p>Please sign in to JustWords to get started.</p>
      {
        error && (
          <p className='text-white bg-red-500 rounded-sm p-2 text-center'>
            {error}
          </p>
        )
      }
      <LoginForm onSubmit={doLogin} />
      <div className='flex justify-evenly items-center w-full'>
        <a
          className='hover:underline hover:text-blue-50'
          href='#'
          onClick={setModal('resetPassword')}
        >
          Forgotten password?
        </a>
        <Button
          grow={false}
          onClick={setModal('signup')}
        >
          No account? Sign up for free!
        </Button>
      </div>
    </Modal>
  );
};
